import { render, staticRenderFns } from "./ActiveGoalBlock.vue?vue&type=template&id=b5890732&scoped=true&lang=pug"
import script from "./ActiveGoalBlock.vue?vue&type=script&lang=js"
export * from "./ActiveGoalBlock.vue?vue&type=script&lang=js"
import style0 from "./ActiveGoalBlock.vue?vue&type=style&index=0&id=b5890732&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5890732",
  null
  
)

export default component.exports